import React from 'react';
import moment from 'moment';

function EpisodeResults({ currentEpisodes }) {
  const episodeUrl = process.env.REACT_APP_FOUR_MIN_EPISODE_URL;

  return (
    <section className='results-container'>
      {currentEpisodes.map((episode) => (
        <div key={episode.id}>
          <a href={episodeUrl + episode.slug}>
            <h3>{episode.title}</h3>
          </a>
          <p className='bold'>Aired {moment.utc(episode.published_at).format('dddd, LL')}</p>
          <p>{episode.description}</p>
          <a className='bold' href={episodeUrl + episode.slug}>
            Learn More
          </a>
          <hr />
        </div>
      ))}
    </section>
  );
}

export default EpisodeResults;
